var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ts-page-title',{attrs:{"title":_vm.$t('productAddonInfo.pageTitle'),"breadcrumb":[
      { text: _vm.$t('home'), href: '/' },
      {
        text: _vm.$t('productAddonInfo.pageTitle'),
        active: true
      }
    ]}}),_c('ts-card',[_c('Tabs',{on:{"on-click":_vm.changeTab}},[_c('TabPane',{attrs:{"label":"Assigned","icon":"ios-analytics-outline"}},[_c('assigned',{ref:"assigned"})],1),_c('TabPane',{attrs:{"label":"Not yet assign","icon":"ios-timer-outline"}},[_c('not-assign',{ref:"not_assign"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }